var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSezzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_280_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1958 11.8533C2.79009 13.4476 5.37453 13.4476 6.96882 11.8533L7.12162 11.7005C7.91833 10.9038 6.32404 6.72419 7.12162 5.92749L1.1958 11.8533Z",
    fill: "url(#paint0_linear_280_138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27537 5.7738L7.12257 5.9266C6.32586 6.7233 7.91927 10.9029 7.12257 11.6996L13.0484 5.7738C12.2508 4.97709 11.2068 4.57874 10.1619 4.57874C9.11698 4.57786 8.07208 4.97709 7.27537 5.7738Z",
    fill: "url(#paint1_linear_280_138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19572 6.08039C-0.398573 7.67469 -0.398573 10.2591 1.19572 11.8534L7.27611 5.77302C8.87041 4.17872 8.87041 1.59429 7.27611 0L1.19572 6.08039Z",
    fill: "url(#paint2_linear_280_138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96867 11.8533C5.37438 13.4476 5.37438 16.0321 6.96867 17.6264L13.0491 11.546C14.6434 9.95167 14.6434 7.36724 13.0491 5.77295L6.96867 11.8533Z",
    fill: "url(#paint3_linear_280_138)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_280_138",
    x1: 6.15265,
    y1: 12.025,
    x2: 3.58716,
    y2: 8.96755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE5DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2095,
    stopColor: "#C558CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5525,
    stopColor: "#AC4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9845,
    stopColor: "#8534D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8333D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_280_138",
    x1: 6.8925,
    y1: 8.13884,
    x2: 13.0482,
    y2: 8.13884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0237,
    stopColor: "#FF5667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6592,
    stopColor: "#FC8B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA28E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_280_138",
    x1: -0.000220816,
    y1: 5.92672,
    x2: 8.47182,
    y2: 5.92672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5126,
    stopColor: "#29D3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6817,
    stopColor: "#53DFB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FF4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_280_138",
    x1: 5.77271,
    y1: 11.6996,
    x2: 14.2447,
    y2: 11.6996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5241,
    stopColor: "#FEA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezzle);
export default __webpack_public_path__ + "static/media/sezzle.333cff7283cbf81adc4c86a99c501aae.svg";
export { ForwardRef as ReactComponent };